import React from "react";
import { TableCell, Link } from "@mui/material";
import { useNavigationContext } from "../../../../contexts";
import isMobile from "is-mobile";

interface ISeeMore {
  toggle: () => void;
  text: string;
}

export const SeeMore: React.FC<ISeeMore> = ({ toggle, text = "" }) => {
  const maxLength = 150;
  const shouldTruncate = text.length > maxLength;
  const displayedText = shouldTruncate ? text.slice(0, maxLength) : text;

  const { setSeeMoreText, setSeeMoreModalWidth } = useNavigationContext();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    setSeeMoreModalWidth(isMobile() ? "400px" : "850px");
    setSeeMoreText(text);
    toggle();
  };

  return (
    <TableCell key={Math.random().toString()} sx={{ padding: "10px" }}>
      {displayedText}
      {shouldTruncate && (
        <Link
          href="#"
          onClick={handleClick}
          sx={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          ver mais.
        </Link>
      )}
    </TableCell>
  );
};
